import React from "react";
import "./formSectionHeader.scss";
import cn from "classnames";

interface FormSectionHeaderProps {
  title: string;
  details?: string | React.ReactNode;
  className?: string;
}

const FormSectionHeader: React.FC<FormSectionHeaderProps> = ({ title, details, className }) => (
  <div className={cn("form-section-header", className)}>
    <div className="header">{title}</div>
    <div className="details text-muted">{details}</div>
  </div>
);

export default FormSectionHeader;
